/** 工单页面共用：状态/优先级文案、关联服务的后台链接、系统时间线解析。文案都是 t() 的 key。 */
import dayjs from 'dayjs';

export const ok = (r) => r && r.status === 'success';

export const STATUS_LABEL = { open: '待处理', answered: '已回复', closed: '已关闭' };
export const STATUS_COLOR = { open: 'orange', answered: 'blue', closed: 'default' };
export const PRIORITY_LABEL = { low: '低', normal: '普通', high: '高', urgent: '紧急' };
export const PRIORITY_COLOR = { low: 'default', normal: 'default', high: 'orange', urgent: 'red' };

export const fmtTime = (v) => (v ? dayjs(v).format('YYYY-MM-DD HH:mm') : '-');

export const fmtSize = (n) => {
    const b = Number(n) || 0;
    if (b < 1024) return `${b} B`;
    if (b < 1024 * 1024) return `${(b / 1024).toFixed(1)} KB`;
    return `${(b / 1024 / 1024).toFixed(1)} MB`;
};

/**
 * service_type → 后台真实路由（resource_admin_path 只作参考，部分产品没有详情页，落到列表页）。
 * 返回 { path, detail }：detail=false 表示只能到列表页自行搜索。
 */
export const resourceRoute = (type, id) => {
    if (!type) return null;
    switch (type) {
        case 'evm': return id ? { path: `/evm/vms/${id}`, detail: true } : { path: '/evm/vms', detail: false };
        case 'cdn': return id ? { path: `/cdn/domains/${id}`, detail: true } : { path: '/cdn/domains', detail: false };
        case 'dns': return id ? { path: `/dns/records/${id}`, detail: true } : { path: '/dns/zones', detail: false };
        case 'domain': return id ? { path: `/domain-registration/detail/${id}`, detail: true } : { path: '/domain-registration/domains', detail: false };
        case 'ssl': return { path: '/ssl/orders', detail: false };
        case 'yeapmail': return id ? { path: `/webmail/users?domain_id=${id}`, detail: true } : { path: '/webmail/domains', detail: false };
        case 'container':
        case 'host': return { path: '/evm/containers/list', detail: false };
        case 'tm': return { path: '/tm/streams', detail: false };
        default: return null;
    }
};

/**
 * 系统消息 body → 变更列表。
 * "status:open>answered;priority:normal>urgent;department:1>2;assignee:->5" 或 "customer_closed"。
 * 返回 [{ field, from, to }] 或 [{ field: 'customer_closed' }]。
 */
export const parseSystemBody = (body) => {
    const s = String(body || '').trim();
    if (!s) return [];
    if (s === 'customer_closed') return [{ field: 'customer_closed' }];
    return s.split(';').filter(Boolean).map((part) => {
        const i = part.indexOf(':');
        if (i < 0) return { field: 'raw', to: part };
        const field = part.slice(0, i);
        const rest = part.slice(i + 1);
        const j = rest.lastIndexOf('>');
        return j < 0 ? { field, to: rest } : { field, from: rest.slice(0, j), to: rest.slice(j + 1) };
    });
};
